import React from 'react'
import { element, bool, string, oneOf } from 'prop-types'
import { connect } from 'react-redux'

import {
  isAuthorized,
  checkIfIsService,
  isAvailableInCurrentPlan,
  getAppPayment,
  isPrivateApp,
  checkCustomPermissions,
  getProductDesignation,
  isProductLicenseActive,
  checkIfUserNotAssignedToActiveProduct,
  isResellerLicense,
} from '@/store/selectors'

import OwnAppInfo from './OwnApp'
import UpgradePlanInfo from './UpgradePlan'
import EmptyAppInfo from './EmptyApp'
import NotEnoughPermissionsInfo from './NotEnoughPermissions'
import DefaultInfo from './DefaultCase'
import InactiveLicense from './InactiveLicense'
import NotAssignedToProduct from './NotAssignedToProduct'
import { ResellerLicense } from './ResellerLicense'

const NotInstallableButton = ({
  id,
  isAvailableInCurrentPlan,
  isAuthorized,
  isPrivateAndPaidApp,
  isService,
  draftMode,
  userHasNotEnoughPermissions,
  designation,
  userIsNotAssignedToActiveProduct,
  isInactiveLicense,
  isReseller,
  ...props
}) => {
  switch (true) {
    case userHasNotEnoughPermissions:
      return <NotEnoughPermissionsInfo {...props} />

    case draftMode:
      return <EmptyAppInfo id={id} {...props} />

    case !isAvailableInCurrentPlan && isAuthorized:
      return <UpgradePlanInfo id={id} designation={designation} {...props} />

    case isPrivateAndPaidApp:
      return <OwnAppInfo id={id} isService={isService} {...props} />

    case userIsNotAssignedToActiveProduct:
      return <NotAssignedToProduct designation={designation} {...props} />

    case isInactiveLicense:
      return <InactiveLicense designation={designation} {...props} />

    case isReseller:
      return <ResellerLicense {...props} />

    default:
      return <DefaultInfo />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps
  const designation = getProductDesignation(state, id)
  const isUserAuthorized = isAuthorized(state)
  const isInactiveLicense =
    !isProductLicenseActive(state, designation) && isUserAuthorized
  const userIsNotAssignedToActiveProduct =
    isUserAuthorized &&
    checkIfUserNotAssignedToActiveProduct(state, designation)
  const isReseller = isResellerLicense(state)

  return {
    isAuthorized: isUserAuthorized,
    isAvailableInCurrentPlan: isAvailableInCurrentPlan(state, id),
    isService: checkIfIsService(state, id),
    userHasNotEnoughPermissions: !checkCustomPermissions(state, id),
    isPrivateAndPaidApp: isPrivateApp(state, id) && getAppPayment(state, id),
    designation,
    isInactiveLicense,
    userIsNotAssignedToActiveProduct,
    isReseller,
  }
}

NotInstallableButton.propTypes = {
  icon: element,
  className: string,
  fullWidth: bool,
  size: oneOf(['compact', 'large']),
  id: string,
  isAvailableInCurrentPlan: bool,
  isPrivateAndPaidApp: bool,
  isAuthorized: bool,
  isService: bool,
  draftMode: bool,
  userHasNotEnoughPermissions: bool,
  designation: string,
  isInactiveLicense: bool,
  userIsNotAssignedToActiveProduct: bool,
  isReseller: bool,
}

export default connect(mapStateToProps)(NotInstallableButton)
